/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createCustomerDownlines',
    message: messages.SUCCESS_CREATE_CUSTOMER_DOWNLINES,
    method: 'POST',
    path: '/customer/:customerId/downlines',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_DOWNLINE,
    requestSchema: requestSchemas.customerDownlines.createCustomerDownlines,
  },
  {
    action: 'getCustomerDownlinesBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_DOWNLINES_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/downlines/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_DOWNLINE,
    requestSchema: requestSchemas.customerDownlines.getCustomerDownlinesBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'recoverCustomerDownlinesBySystemGameId',
    message: messages.SUCCESS_RECOVER_CUSTOMER_DOWNLINES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/downlines/:systemGameId/recover',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.RECOVER_CUSTOMER_DOWNLINE,
    requestSchema: requestSchemas.customerDownlines.recoverCustomerDownlinesBySystemGameId,
  },
  {
    action: 'removeCustomerDownlinesBySystemGameId',
    message: messages.SUCCESS_REMOVE_CUSTOMER_DOWNLINES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/downlines/:systemGameId/remove',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.REMOVE_CUSTOMER_DOWNLINE,
    requestSchema: requestSchemas.customerDownlines.removeCustomerDownlinesBySystemGameId,
  },
  {
    action: 'updateCustomerDownlineById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_DOWNLINE_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/downline/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_DOWNLINE,
    requestSchema: requestSchemas.customerDownlines.updateCustomerDownlineById,
  },
];
